import { mapFirstContactPerson } from '../DataTypes/contactPersonMapper';
import { mapBasePageProperties } from './basePagePropertiesMapper';
import logger from '3-foundation/Logging/logger';

//TODO find a suitable way to share type between this file and mapFirstContactPerson()
interface Props extends Umbraco.BasePage {
	contactPerson: Umbraco.ContactPerson[];
}

export const mapContactPersonPageProperties = async (
	{ contactPerson, ...properties }: Props,
	pageId: string,
	siteId: string,
	locale: string,
): Promise<Content.ContactPersonPageProperties> => {
	try {
		return {
			...(await mapBasePageProperties(properties, siteId, locale)),
			contactPerson: mapFirstContactPerson(contactPerson),
		};
	} catch (e) {
		logger.error('Could not map ContactPersonPage Properties', e);
		throw new Error('Could not map ContactPersonPage Properties', e);
	}
};
